const inputFields = [
    {
      name: 'email',
      type: 'email',
      label: 'Email*',
      placeholder: 'Email',
    },
];

export default inputFields;